module.exports = __webpack_public_path__ + "img/appD3.4f24aa8f.svg";